import { z } from 'zod';

export const paymentProvidersResponseSchema = z.object({
  providerIds: z.array(z.string()),
});
export type PaymentProvidersResponse = z.infer<typeof paymentProvidersResponseSchema>;
